import gql from "graphql-tag"

export const getGdprPreferencesQuery = gql`
  query getGdprPreferences($email: String!) {
    getGdpr(email: $email) {
      service
      email
      source
      marketing
      profiling
      third_parties
      terms_and_conditions
      date
    }
  }
`
